import React, { useEffect, useState } from "react";
import { Container, Row, Col, Button, Card, Table } from "reactstrap";
import SimpleBar from "simplebar-react";
import { get, del, put } from "../../../api/axios";
import endpoints from "../../../api/endpoints";
import { toast, Bounce } from "react-toastify";
import { useNavigate, useLocation } from "react-router-dom";
import { convertFromRaw } from "draft-js";
import { stateToHTML } from "draft-js-export-html";

export default function FaqDetails() {
  document.title = "FAQ Detail | Elevated - Admin Dashboard";
  const location = useLocation();
  const navigate = useNavigate();
  const blogId = location.state?.blogData?.data?.id;
  const [blogData, setblogData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [blogContent, setBlogContent] = useState("");
  const fetchblog = async (id) => {
    setLoading(true);
    try {
      const response = await get(`${endpoints.help}/${id}`);
      setblogData(response?.data?.data);

      const contentState = convertFromRaw(
        response?.data?.data?.content?.content
      );
      const htmlContent = stateToHTML(contentState);

      setBlogContent(htmlContent);
    } catch (error) {
      console.error("Error fetching Faq data:", error);
      setblogData(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (blogId) {
      fetchblog(blogId);
    }
  }, [blogId]);

  const handleEditBlog = () => {
    if (blogData) {
      navigate(`/add-faq?blogId=${blogId}`);
    }
  };

  const handleDeleteBlog = async () => {
    try {
      await del(`${endpoints.help}/${blogId}`);
      setblogData((prevData) => prevData.filter((blog) => blog.id !== blogId));
      toast.success("Faq Deleted Successfully", {
        position: "bottom-center",
        theme: "colored",
        transition: Bounce,
      });
      navigate("/list-faq");
    } catch (error) {
      console.error("Error deleting Faq:", error);
    }
  };

  return (
    <div className="">
      <Container fluid>
        <Card className="rounded-4 p-4" style={{ minHeight: "550px" }}>
          <Row className="justify-content-between align-items-center">
            <Col md={6}>
              <h2 className="fw-bold font-size-20 ff-sora primary-black">
                FAQ Details
              </h2>
            </Col>
            <Col md={6} xs={12} className="d-flex justify-content-end">
              <Button
                color="white"
                className="me-2 rounded-pill1"
                onClick={handleDeleteBlog}
              >
                Delete FAQ
              </Button>
              <Button className="rounded-pill" onClick={handleEditBlog}>
                Edit FAQ
              </Button>
            </Col>
          </Row>

          <Row>
            <Col>
              <span
                className="font-size-16 fw-bold ff-sora secondary-black"
                style={{ color: "#525252" }}
              >
                {blogData.title}
              </span>

              <div dangerouslySetInnerHTML={{ __html: blogContent }}></div>
            </Col>
          </Row>
        </Card>
        <div
          className="d-flex justify-content-between align-items-center"
          style={{
            height: "10px",
            position: "sticky",
            bottom: "0",
            zIndex: "10",
          }}
        ></div>
      </Container>
    </div>
  );
}
